"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimelineSeparatorPropType = exports.TimelineOppositeContentPropType = exports.TimelineItemPropType = exports.TimelineDotPropType = exports.TimelineContentPropType = exports.TimelineConnectorPropType = exports.TimelineActivityPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var TimelineConnectorPropType = _propTypes["default"].shape({
  classes: _propTypes["default"].shape({
    root: _propTypes["default"].string
  })
});
exports.TimelineConnectorPropType = TimelineConnectorPropType;
var TimelineContentPropType = _propTypes["default"].shape({
  classes: _propTypes["default"].shape({
    alignRight: _propTypes["default"].string,
    root: _propTypes["default"].string
  })
});
exports.TimelineContentPropType = TimelineContentPropType;
var TimelineDotPropType = _propTypes["default"].shape({
  classes: _propTypes["default"].shape({
    defaultGrey: _propTypes["default"].string,
    defaultPrimary: _propTypes["default"].string,
    defaultSecondary: _propTypes["default"].string,
    outlinedGrey: _propTypes["default"].string,
    outlinedPrimary: _propTypes["default"].string,
    outlinedSecondary: _propTypes["default"].string,
    root: _propTypes["default"].string
  }),
  color: _propTypes["default"].oneOf(['grey', 'inherit', 'primary', 'secondary']),
  variant: _propTypes["default"].oneOf(['default', 'outlined'])
});
exports.TimelineDotPropType = TimelineDotPropType;
var TimelineItemPropType = _propTypes["default"].shape({
  classes: _propTypes["default"].shape({
    alignAlternate: _propTypes["default"].string,
    alignLeft: _propTypes["default"].string,
    alignRight: _propTypes["default"].string,
    content: _propTypes["default"].string,
    missingOppositeContent: _propTypes["default"].string,
    oppositeContent: _propTypes["default"].string,
    root: _propTypes["default"].string
  })
});
exports.TimelineItemPropType = TimelineItemPropType;
var TimelineOppositeContentPropType = _propTypes["default"].shape({
  classes: _propTypes["default"].shape({
    alignRight: _propTypes["default"].string,
    root: _propTypes["default"].string
  })
});
exports.TimelineOppositeContentPropType = TimelineOppositeContentPropType;
var TimelineSeparatorPropType = _propTypes["default"].shape({
  classes: _propTypes["default"].shape({
    root: _propTypes["default"].string
  })
});
exports.TimelineSeparatorPropType = TimelineSeparatorPropType;
var TimelineActivityPropType = _propTypes["default"].shape({
  connectorProps: TimelineConnectorPropType,
  contentProps: TimelineContentPropType,
  date: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  description: _propTypes["default"].node.isRequired,
  dotProps: TimelineDotPropType,
  icon: _propTypes["default"].element,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  itemProps: TimelineItemPropType,
  oppositeContentProps: TimelineOppositeContentPropType,
  separatorProps: TimelineSeparatorPropType,
  subtitle: _propTypes["default"].node,
  time: _propTypes["default"].string
});
exports.TimelineActivityPropType = TimelineActivityPropType;